import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {RootState} from '../../../../../store/redux';

import attention from '../../../../../assets/image/attention.png';
import DotsLoading from '../../../../../components/dotsLoading';
import CardInputGroup from '../../../../../components/mazraeKit/CardInputGroup';
import MyStoreCard from '../../../../../components/mazraeKit/cards/myStoreCard';
import CustomSearchBox from '../../../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import {useGetInputGroupList} from '../../../../../services/hookService';
import useGetStoreAds from '../../../../../services/hookService/getStoreAds/useGetStoreAds';
import {clearFilter} from '../../../../../store/redux/myStore';
import {getValidImage} from '../../../../../utilities/helper/getValidImage/getValidImage';
import useDebounce from '../../../../../utilities/hooks/useDebounce/useDebounce';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import MyStoreFilterBottomSheet from '../../elements/bottomSheetLists/myStoreFilterBottomSheet';
import MyStoreFiltersAdvertisement from '../../elements/myStoreFiltersAdvertisementList';
import NotFoundIcon from './../../../../../assets/image/sponsor/404.svg';
import {useSafeNavigateBack} from './useSafeNavigate';
import NoItemFoundPage from '../../../../../components/noItemFoundPage';

const MyStoreAdvertisement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // const {store_guid} = useParams();

  const [inputValue, setInputValue] = useState<string>('');
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [advertisementCode, setAdvertisementCode] = useState(0);

  const debouncedValue = useDebounce(inputValue, 2000);
  const {inputGroupList} = useGetInputGroupList();

  const safeNavigateBack = useSafeNavigateBack(
    location?.state?.from ?? '/my-account',
  );
  const onClickHandler = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    setAdvertisementCode(item.code as number);
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const state = useSelector((state: RootState) => state.myStore);

  const payload = {
    search: debouncedValue || undefined,
    order_by: state.sorting || undefined,
    advertisement_type:
      advertisementCode !== 0
        ? CodeToInputGroupName[advertisementCode]
        : undefined,
    status_list:
      Object.keys(state.status_list)
        .filter(
          //@ts-ignore
          (key: string) => state.status_list[key],
        )
        .join(',') || undefined,
    ad_type: 'store',
    // store_guid: store_guid,
  };

  const {data, isLoading, loaderRef, isFetchingNextPage} =
    useGetStoreAds(payload);

  return (
    <div className="relative flex flex-col w-full h-full">
      <CustomHeader
        title="آگهی‌های فروشگاه من"
        preIcon="icon-nameArrow---Right"
        onClick={() => {
          safeNavigateBack();
          dispatch(clearFilter());
        }}
        isActiveRightIcon
      />
      <div className="w-full px-3 my-3 ">
        <CustomSearchBox
          placeholder="جستجو در فروشگاه "
          type="text"
          value={inputValue}
          inputCustomClass="!pr-8"
          isFloating={false}
          preIcon="icon-nameSearch"
          onChange={onChangeHandler}
          {...{inputValue, setInputValue}}
        />
        <div className="flex items-center w-full gap-2 mt-3">
          <button
            className="flex items-center gap-2 px-3 py-2 text-gray-700 border rounded-full w-fit"
            onClick={() => setOpenBottomSheet(true)}
          >
            <i className="font-bold icon-nameFilter text-xxl" />
            <span className="text-sm whitespace-nowrap">فیلتر کردن</span>
          </button>
          <MyStoreFiltersAdvertisement />
        </div>
        <div className="flex gap-1 my-2 overflow-x-auto no-scrollbar">
          {inputGroupList &&
            inputGroupList.length > 0 &&
            [
              {
                image:
                  'https://my-store-input-groups.s3.ir-thr-at1.arvanstorage.ir/all%20.svg',
                guid: '1',
                title: 'همه',
                code: 0,
                icon: '',
              },
              ...inputGroupList.filter(item => item.code !== 18),
            ].map(item => {
              return (
                <div className="flex justify-center w-full" key={item.guid}>
                  <CardInputGroup
                    isActive={item.code === advertisementCode}
                    isBoled={false}
                    title={item.title}
                    image={item.image}
                    guid={item.guid}
                    clickHandler={() => onClickHandler(item)}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <section className="flex flex-col h-full gap-4 px-3 overflow-y-auto ">
        {isLoading ? (
          <div className="my-auto">
            <DotsLoading />
          </div>
        ) : (
          <>
            {!data.length ? (
              <NoItemFoundPage />
            ) : (
              data?.map((item: INewAdvData) => (
                <MyStoreCard
                  key={item.id}
                  title={item.title}
                  storeName={item.store?.title}
                  rate={item.rate}
                  image={
                    (item?.main_image &&
                      getValidImage(item?.main_image, 'original')) ||
                    (item?.sub_brand_main_image &&
                      getValidImage(item?.sub_brand_main_image, 'original'))
                  }
                  discount_amount={item.discount_amount}
                  created_at={item.created_at}
                  advertisementGuid={item.id}
                  advertisement_type={item.advertisement_type}
                  status={item.status}
                />
              ))
            )}

            {/* This div acts as a sentinel for triggering infinite scroll */}
            <div ref={loaderRef} className="pb-4 tw-mt-4 tw-text-center">
              {isFetchingNextPage ? <DotsLoading /> : null}
            </div>
          </>
        )}
      </section>

      <MyStoreFilterBottomSheet {...{openBottomSheet, setOpenBottomSheet}} />
      <MainFooter />
    </div>
  );
};

export default MyStoreAdvertisement;
